import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import StorageIcon from "@mui/icons-material/Storage";
import {
  error,
  planogramme,
  sections,
  tableauDeBord,
  statistiques,
} from "../constante/routes";
import AppError from "../pages/errors/AppError";
import { PlanogrammePage } from "../pages/planogramme/PlanogrammePage";
import SectionPage2 from "../pages/section2/SectionPages";
import { RouteType } from "./config";
import { DashboardPage } from "../pages/dashboard/DashboardPage";
// import StatistiquesPage from "../pages/statistiques/StatistiquesPage";
import StatistiquesWrapper from "../pages/statistiques/StatistiquesPage";
import DashboardPage2 from "../pages/dashboard/DashboardPage2";

const appRoutes: RouteType[] = [
  {
    index: true,
    element: <PlanogrammePage />,
    state: "home",
  },
  {
    path: planogramme,
    element: <PlanogrammePage />,
    state: "planogramme",
    sidebarProps: {
      displayText: "Planogramme",
      icon: <StorageIcon />,
    },
  },
  {
    path: sections,
    element: <SectionPage2 />,
    state: "sections",
    sidebarProps: {
      displayText: "Sections",
      icon: <AutoAwesomeMosaicIcon />,
    },
  },
  {
    path: tableauDeBord,
    element: (
      <>
        <DashboardPage2 />
      </>
    ),
    state: "dashboard",
  },
  {
    path: error,
    element: <AppError />,
    state: "error",
  },
  {
    path: statistiques,
    element: <StatistiquesWrapper />,
    state: "statistiques",
  }
];

export default appRoutes;
